import { useUserContext } from '@/contexts/UserContext';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { Avatar } from '@netfront/ui-library';
import React from 'react';
type AvatarSize = React.ComponentProps<typeof Avatar>['size'];
const UserAvatar = (props: { size?: AvatarSize }) => {
  const { user } = useUserContext();
  return !user ? (
    <SkeletonLoader additionalClassNames="c-avatar" />
  ) : (
    <Avatar title={`${user.firstName} ${user.lastName}`} size={props.size} />
  );
};

export default UserAvatar;
